<template>
  <div class="wd-my-4 wd-mb-1 wd-px-5">
    <h2 class="wd-text-xl wd-font-medium wd-mb-3">{{ $t('all_customer_notice') }}</h2>
    <div>
      <ul ref="introInfo" class="!wd-px-0 wd-list-none">
        <li v-for="(item, idx) in items" :key="idx">
          <p class="ma-0">{{ item }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default defineComponent({
  props: {
    items: { type: Array, default: () => [] },
  },
  setup() {},
})
</script>
